<template>
  <div class="tworders">
    <div class="container">
      <!-- Content here -->
      <br />
      <nav class="navbar navbar-light bg-light">
        <span class="navbar-brand mb-0 h1">台灣廠商委託代買幫訂單</span>
      </nav>

      <div class="card">
        <div class="card-body">
          <b-button
            variant="outline-info"
            @click="filterDisplaysButton(0)"
            style="float: left; margin-right: 10px; margin-top: 5px"
          >
            列出
            <b>尚未付款訂單</b>
          </b-button>
          <b-button
            variant="outline-info"
            @click="filterDisplaysButton(2)"
            style="float: left; margin-right: 10px; margin-top: 5px"
          >
            列出
            <b>已付款</b>
          </b-button>
          <b-button
            variant="outline-info"
            @click="filterDisplaysButton(10)"
            style="float: left; margin-right: 10px; margin-top: 5px"
          >
            列出
            <b>廠商確認訂單</b>
          </b-button>
          <b-button
            variant="outline-info"
            @click="filterDisplaysButton(20)"
            style="float: left; margin-right: 10px; margin-top: 5px"
          >
            列出
            <b>廠商出貨完成訂單</b>
          </b-button>
        </div>
      </div>

      <div v-if="displayViews != ''">
        <!-- conent -->
        <div
          v-for="(displayView, index) in filterDisplays"
          v-bind:key="(displayView, index)"
        >
          <div>
            <div class="list-group">
              <li
                class="mt-3 mb-3 list-group-item list-group-item-action flex-column align-items-start"
              >
                <div class="d-flex w-100 justify-content-between">
                  <small></small>
                </div>
                <!-- <input type="checkbox" class="checkbox_size" :value="displayView.key" v-model="checkboxedProds" /> -->
                <h5 class="mb-1">
                  <b>訂單編號:{{ displayView.key }}</b>
                </h5>
                <p class="mb-1">
                  <b
                    >成立訂單日期:
                    {{
                      new Date(displayView.c_epoch)
                        | moment('YYYY-MM-DD, HH:mm:ss')
                    }}</b
                  >
                </p>
                <div>狀態</div>
                <div v-if="displayView.status == 0">
                  <b>
                    <h3>
                      <b-badge variant="warning">等待付款</b-badge>
                    </h3>
                  </b>
                </div>
                <div v-if="displayView.status == 2">
                  <h3>
                    <b-badge variant="info">已付款</b-badge>
                  </h3>
                </div>
                <div v-if="displayView.status == 10">
                  <h3>
                    <b-badge variant="info">廠商確認訂單</b-badge>
                  </h3>
                </div>
                <div v-if="displayView.status == 20">
                  <h3>
                    <b-badge variant="success">出貨完成</b-badge>
                  </h3>
                </div>
                <div v-if="displayView.status == 40">
                  <h3>
                    <b-badge variant="dark">訂單取消</b-badge>
                  </h3>
                </div>
                <br />
                <div class="card">
                  <div class="card-body">
                    <div class="card-title">收件資訊</div>
                    <div>收件者: {{ displayView.delivery[0].name }}</div>
                    <div>電話: {{ displayView.delivery[0].phone }}</div>
                    <div>地址: {{ displayView.delivery[0].address }}</div>
                  </div>
                </div>
                <br />
                <div class="card">
                  <div class="card-body">
                    <div class="card-title">商品資訊</div>
                    <div
                      v-for="(product, productIndex) in displayView.products"
                      v-bind:key="(product, productIndex)"
                    >
                      <div class="card">
                        <p class="mb-1">
                          <img
                            v-bind:src="product.main_image"
                            height="100"
                            width="100"
                            referrerpolicy="no-referrer"
                          />
                        </p>
                        <div>{{ product.select.product_name }}</div>
                        <div class="card-body">
                          <!-- <p>商品編號:{{product.select.product_id}}</p> -->
                          <p>規格:{{ product.select.sku_name }}</p>
                          <p>尺寸:{{ product.select.size_name }}</p>
                          <p>顏色:{{ product.select.color_name }}</p>
                          <p>數量:{{ product.select.quantity }}</p>
                          <p>價格:{{ product.select.price }}</p>
                        </div>
                      </div>
                    </div>
                    <br />
                    <div>
                      <b>商品總數量: {{ displayView.total_quantity }}</b>
                    </div>

                    <div>
                      <b
                        >商品總金額: {{ displayView.total_products_price }}元</b
                      >
                    </div>

                    <div>
                      <b>運費金額: {{ displayView.freight }}元</b>
                    </div>

                    <div>
                      <b
                        >代買幫手續費金額: {{ displayView.processing_fee }}元</b
                      >
                    </div>

                    <div>
                      <b>綠界金流費: {{ displayView.ecpay_fee }}元</b>
                    </div>

                    <div>
                      <b>總共金額: {{ displayView.total_price }}元</b>
                    </div>
                  </div>
                </div>
                <br />
                <div v-if="displayView.pay != undefined">
                  <div class="card">
                    <div class="card-body">
                      <div>付款資訊</div>
                      <!-- <div>交易編號:{{displayView.pay.payment_id}}</div> -->
                      <div>
                        繳費銀行代碼:{{ displayView.pay.payment_bank_code }}
                      </div>
                      <div>
                        繳費虛擬帳號:{{ displayView.pay.paymentv_account }}
                      </div>
                    </div>
                  </div>
                </div>
                <br />
              </li>
            </div>
          </div>
        </div>
        <!-- conent -->
        <!-- footer -->
        <div class="jumbotron jumbotron-fluid">
          <div class="container">
            <h1 class="display-4"></h1>
            <p class="lead">總共:{{ orderCount }}訂單</p>
          </div>
        </div>
        <!-- footer -->
      </div>
      <div v-else>
        <div class="jumbotron jumbotron-fluid">
          <div class="container">
            <h1 class="display-4"></h1>
            <p class="lead">目前沒有任何訂單</p>
          </div>
        </div>
      </div>
    </div>
    <loading
      loader="bars"
      :active.sync="isLoading"
      :can-cancel="true"
      :is-full-page="false"
    ></loading>
    <v-dialog />
  </div>
</template>
<style type="text/css">
.P-logo {
  height: 100px;
  width: 100px;
}

.countdown {
  padding: 0px 10px;
}

.expiry_date {
  font-weight: bold;
}

.send_date {
  font-weight: bold;
}

.count_l1 {
  font-weight: bold;
}

.count_l2 {
  font-weight: bold;
}

.prod_detail {
  font-size: 10px;
}

.category_text {
  text-align: left;
  padding: 10px 0px;
}

.category_scrollview {
  overflow: hidden;
  width: auto;
  overflow-x: auto;
  white-space: nowrap;
}

.category_button {
  display: inline-block;
  padding: 0px 2px;
}

.card_button {
  padding: 10px 0px;
}

.card_contain {
  padding: 20px;
  width: 18rem;
}

.checkbox_size {
  zoom: 2;
  width: 20px;
  height: 20px;
}
</style>
<script>
import VueLoading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import axios from 'axios'
export default {
  name: 'tworders',
  components: {
    loading: VueLoading,
  },
  data: function () {
    return {
      apiUrl: process.env.VUE_APP_API_URL,
      isLoading: true,
      userId: '',
      userImage: '',
      userName: '',
      categoryViews: '',
      displayViews: '',
      nowStatus: 0,
      checkUnChatbotSigninStatus: false,
      filterStatus: 0,
      filterDisplays: [],
      orderCount: 0,
    }
  },
  watch: {},
  computed: {},
  methods: {
    filterDisplaysButton: function (status) {
      const vm = this
      vm.filterStatus = status
      vm.filterDisplayViews()
    },
    filterDisplayViews: function () {
      const vm = this
      vm.isLoading = true
      vm.filterDisplays = []
      for (var object in vm.displayViews) {
        if (vm.displayViews[object].status == vm.filterStatus) {
          vm.filterDisplays.push(vm.displayViews[object])
          vm.orderCount = vm.filterDisplays.length
        }
      }
      if (vm.filterDisplays == '') {
        vm.$toast.open({
          message: '目前沒有訂單!',
          type: 'error',
        })
      } else {
        vm.$toast.open({
          message: '查詢成功!',
          type: 'success',
        })
      }
      vm.isLoading = false
      this.$forceUpdate()
    },
    checkUnChatbotSignin: function () {
      const vm = this
      if (!localStorage.userId) {
        this.$modal.show('dialog', {
          title: '🙋您尚未登入FB會員',
          text: '請先登入才能使用此服務喔⚡',
          buttons: [
            {
              title: '關閉',
            },
            {
              title: '👉用FB登入',
              handler: () => {
                window.location = 'https://m.me/2266831083395361'
              },
            },
          ],
        })

        vm.checkUnChatbotSigninStatus = true
        return true
      } else {
        vm.userName = localStorage.userName
        vm.checkUnChatbotSigninStatus = false
        return false
      }
    },
    GetTwOrderByUserId: function (userId) {
      const vm = this
      vm.isLoading = true
      vm.$toast.open({
        message: '查詢中!',
        type: 'success',
      })
      axios
        .post(vm.apiUrl + 'GetTwOrderByUserId', {
          userId: userId,
        })
        .then(function (response) {
          if (response.data.length == 0) {
            // alert("系統錯誤請稍後再試");
            vm.$toast.open({
              message: '目前沒有訂單!',
              type: 'error',
            })
          } else {
            vm.displayViews = response.data
            vm.filterDisplayViews()
            vm.$toast.open({
              message: '查詢成功!',
              type: 'success',
            })
          }
          vm.isLoading = false
          document.body.scrollTop = 0
          document.documentElement.scrollTop = 0
          // console.log(response.data);
        })
        .catch(function (error) {
          alert(error)
          // console.log(error);
        })
    },
  },
  mounted() {
    const vm = this
    vm.isLoading = false

    try {
      if (vm.$route.query.userId) {
        localStorage.userId = decodeURI(vm.$route.query.userId)
      }
      vm.checkUnChatbotSignin()
      vm.GetTwOrderByUserId(localStorage.userId)
    } catch (e) {
      // console.info(e);
      alert(e)
    }
  },
}
</script>
